export default __webpack_public_path__ + "static/youtube-e3a9f384529a415c702316d82f87970c.gif";